import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import "../../../styles/reports/reports.scss";
import TempSummary from "./tempSummary";
import ExceptionTable from "./exceptionTable";
import LogTable from "./logTable";
import TemperatureChart from "./temperatureChart";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import { utcToDate } from "../../../utils/dateConvert";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import Calendar from "react-calendar/dist/umd/Calendar";
import Select from "react-select";
import GridLoader from "react-spinners/GridLoader";
import {
  setLoadingPage,
  setErrorMessage,
  setHeaderVisible,
  setReportAssetId,
  setReportCalendatDate,
  setReportAssetName,
  setReportGroupId,
} from "../../../reducers/actions";
import queryString from "query-string";
import moment from "moment";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import GroupWarning from "../../commoncomponents/groupWarning";
import TimeZoneConvert from "../../../utils/timeZoneConvert";

const REPORT_FILTERING_STORAGE_KEY = "reportUseFiltering";

const getSavedReportFilteringState = () => {
  const savedValue = localStorage.getItem(REPORT_FILTERING_STORAGE_KEY);
  return savedValue === null ? true : savedValue !== "false";
};

class Temperature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetId: "",
      groupId: "",
      groupDetails: [],
      AssetList: [],
      assetLoader: false,
      isLoading: false,
      calendarSelectedDate: new Date(),
      calendarShow: false,
      tempDataExceptionList: [],
      tempDataLogList: [],
      timeX: [],
      tempY: [],
      xPoint: [],
      assetName: "",
      assetSelect: false,
      dateSelect: true,
      reportStart: "",
      reportEnd: "",
      reportDuration: "",
      thresholdA: "",
      thresholdB: "",
      generated: "",
      showContent: false,
      reportLoader: false,
      errorLoader: false,
      errorMessage: "",
      generatedDate: moment().format("DD-MMM hh:mm a"),
      selectedDate: moment().format("YYYY-MM-DD"),
      dataPlaceholder: moment().format("dddd Do MMMM, YYYY"),
      contentChart: false,
      totalGraph: [],
      totalGraphSecond: [],
      timeUtc: [],
      utcObj: {},
      loadedReportParams: null,
    };
    this.groupId = "";
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    const searchDate = values.assetDate || values.SearchDate || values.searchDate;
    const assetId = values.assetId || values.AssetId || values.id;
    const assetName = values.assetName || values.AssetName || values.name || "Selected Asset";
    const groupId = values.groupId || values.GroupId;
    const urlState = {};

    if (groupId) {
      this.groupId = groupId;
      urlState.groupId = groupId;
      urlState.assetLoader = true;
      this.props.setReportGroupIdAction(groupId);
      this.getAssets(groupId);
    }

    if (assetId) {
      if (searchDate !== undefined && searchDate !== "null") {
        urlState.selectedDate = searchDate;
        urlState.ReportDate = searchDate;
        urlState.calendarSelectedDate = moment(searchDate).toDate();
        urlState.dataPlaceholder = moment(searchDate).format("dddd Do MMMM, YYYY");
      }

      urlState.assetName = assetName;
      urlState.assetCustomerName = assetName;
      urlState.assetId = assetId;
      urlState.assetSelect = true;
      this.setState(urlState, this.handleCreateReport);
    } else if (Object.keys(urlState).length > 0) {
      this.setState(urlState);
    }

    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (GroupList.status === 200) {
        this.setState({ isLoading: false, groupDetails: GroupList.data });
      } else {
        this.setState({ isLoading: true });
      }
    } catch (e) {
      console.warn("Report request failed");
    }

    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false });
    }
  }

  getTemperatureData = async (url) => {
    this.props.setLoadingPageAction(true);
    this.setState({
      reportLoader: true,
      errorLoader: false,
      errorMessage: "",
      showContent: false,
    });

    let assetID = this.state.assetId;
    let assetName = this.state.assetName;

    this.props.setReportAssetIdAction(assetID);
    this.props.setReportAssetNameAction(assetName);
    this.props.setReportCalendatDateAction(this.state.selectedDate);
    this.props.setReportGroupIdAction(this.state.groupId);

    try {
      let tempData = await axios.post(
        url,
        {
          AssetId: this.state.assetId,
          SearchDate: this.state.selectedDate,
          Timezone: localStorage.getItem("timeZoneID"),
          UseFiltering: getSavedReportFilteringState(),
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.props.setLoadingPageAction(false);
      this.setState({ contentChart: false });
      this.setState({
        tempDataExceptionList: tempData.data.temperatureExceptionsDtos,
        tempDataLogList: tempData.data.temperatureLogsDtos,
        reportStart: tempData.data.reportStart,
        reportEnd: tempData.data.reportEnd,
        reportDuration: tempData.data.reportDuration,
        thresholdA: tempData.data.tempAthreshold,
        thresholdB: tempData.data.tempBthreshold,
        showContent: true,
        reportLoader: false,
        errorLoader: false,
        generatedDate: moment().format("DD-MMM, hh:mm a"),
        isTempBEnabled: tempData.data.assetTempB,
        isTempAEnabled: tempData.data.assetTempA,
        isDoorSensorEnabled: tempData.data.assetDoorSensor
      });
      this.setGraph(tempData.data.temperatureLogsDtos);
    } catch (e) {
      if (e && e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
      const responseMessage = e.response && e.response.data
        ? (typeof e.response.data === "string" ? e.response.data : JSON.stringify(e.response.data))
        : "No Data Available";
      this.setState({
        reportLoader: false,
        errorLoader: true,
        errorMessage: responseMessage,
      });
    }
  };

  setGraph = (data) => {
    var timeX = [];
    var timeUtc = [];
    var utcObj = {};
    var tempY = [];
    var totalGraph = [];
    var totalGraphSecond = [];
    var timeZoneID = localStorage.getItem("timeZoneID");

    data.forEach((single) => {
      let newtime = moment.utc(single.date).tz(timeZoneID).format();
      var timezoneOffset = moment(newtime);
      var timeZoneSeconds = timezoneOffset._tzm;
      var myDate = new Date(single.date);
      var result = myDate.getTime();
      var seconds = timeZoneSeconds * 60 * 1000;

      let value = result + seconds;
      let valueUtc = utcToDate(single.date);
      utcObj[value] = valueUtc;
      let point = parseFloat(single.tempA);
      let pointSecond = parseFloat(single.tempB);
      tempY.push(point);
      let totalPoint = [value, point];
      let totalPointSecond = [value, pointSecond];

      if (!timeX.includes(value)) {
        timeX.push(value);
        timeUtc.push(valueUtc);
        totalGraph.push(totalPoint);
        totalGraphSecond.push(totalPointSecond);
      }
    });

    let xPoint = ["00:30", "01:30"];
    this.setState({
      timeX,
      tempY,
      utcObj,
      timeUtc,
      totalGraph,
      totalGraphSecond,
      xPoint,
    });
  };

  getAssets = async (groupId) => {
    try {
      let AssetList = await axios.get(`${apiHost}/api/Notification/AssetsByGroupId/${groupId || this.groupId}?IsReport=true`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        AssetList: AssetList.data.paggedlist,
        assetLoader: false,
      });
    } catch (e) {
      console.warn("Report request failed");
    }
  };

  handleGroupSelection = (selectedGroup) => {
    if (!selectedGroup) {
      this.groupId = "";
      this.setState({
        groupId: "",
        assetCustomerName: "",
        assetName: "",
        assetId: "",
        assetSelect: false,
        AssetList: [],
        assetLoader: false,
      });
      this.props.setReportGroupIdAction("");
      return;
    }

    const group = selectedGroup.data;
    this.groupId = group.groupId;
    this.setState({
      groupId: group.groupId,
      assetCustomerName: "",
      assetName: "",
      assetId: "",
      assetSelect: false,
      AssetList: [],
      assetLoader: true,
    });
    this.props.setReportGroupIdAction(group.groupId);
    this.getAssets(group.groupId);
  };

  handleAssetSelection = (selectedAsset) => {
    if (!selectedAsset) {
      this.setState({
        assetId: "",
        assetName: "",
        assetCustomerName: "",
        assetSelect: false,
      });
      return;
    }

    const asset = selectedAsset.data;
    this.setState({
      assetId: asset.assetId,
      assetName: asset.name,
      assetCustomerName: asset.name,
      assetSelect: true,
    });
  };

  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };

  onChangeDate = (date) => {
    this.setState({
      calendarSelectedDate: date,
      dateSelect: true,
      selectedDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };

  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  getQuickReportUrl = (path) => {
    const params = new URLSearchParams({
      assetId: this.state.assetId,
      assetName: this.state.assetName || "",
      SearchDate: this.state.selectedDate,
      assetDate: this.state.selectedDate,
      UseFiltering: String(getSavedReportFilteringState()),
    });

    if (this.state.groupId) {
      params.set("groupId", this.state.groupId);
    }

    return `${path}?${params.toString()}`;
  };

  openQuickReport = (path) => {
    if (!this.state.assetId) {
      return;
    }

    const href = this.getQuickReportUrl(path);
    const parentWindow = window.opener && !window.opener.closed ? window.opener : window;
    const reportWindow = parentWindow.open(href, "_blank");

    if (reportWindow) {
      reportWindow.focus();
      return;
    }

    window.open(href, "_blank");
  };

  updateCurrentReportUrl = () => {
    const href = this.getQuickReportUrl(this.props.location.pathname);
    this.props.history.replace(href);
  };

  handleCreateReport = () => {
    if (!this.state.assetId) {
      this.setState({
        showContent: false,
        errorLoader: true,
        reportLoader: false,
        errorMessage: "Select an asset before creating the Temperature report.",
      });
      return;
    }

    this.updateCurrentReportUrl();
    this.setState({
      loadedReportParams: {
        assetId: this.state.assetId,
        selectedDate: this.state.selectedDate,
        groupId: this.state.groupId,
      },
    });
    let url = `${apiHost}/api/Report/TemperatureReport`;
    this.getTemperatureData(url);
  };

  render() {
    const selectStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 44,
        backgroundColor: "#f8fafc",
        borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
        borderRadius: 8,
        boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
        "&:hover": {
          borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
        },
      }),
      indicatorSeparator: (base) => ({
        ...base,
        backgroundColor: "#dbe4ef",
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
        color: state.isSelected ? "#fff" : "#26354f",
        fontSize: 13,
      }),
      placeholder: (base) => ({
        ...base,
        color: "#7e8da1",
      }),
      singleValue: (base) => ({
        ...base,
        color: "#17233c",
        fontWeight: 700,
      }),
      menu: (base) => ({
        ...base,
        zIndex: 200,
        borderRadius: 8,
        overflow: "hidden",
      }),
    };

    const groupOptions = this.state.groupDetails.map((group) => ({
      value: group.groupId,
      label: `${group.customername} - ${group.groupName}`,
      data: group,
    }));

    const selectedGroupOption =
      groupOptions.find((option) => option.value == this.state.groupId) || null;

    const assetOptions = this.state.AssetList.map((asset) => ({
      value: asset.assetId,
      label: `${asset.name}${asset.customerName ? ` - ${asset.customerName}` : ""}`,
      data: asset,
    }));

    const selectedAssetOption =
      assetOptions.find((option) => option.value == this.state.assetId) ||
      (this.state.assetId
        ? {
            value: this.state.assetId,
            label: this.state.assetName,
            data: {
              assetId: this.state.assetId,
              name: this.state.assetName,
            },
          }
        : null);
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingReportChanges = !!(
      loadedReportParams &&
      this.state.assetId &&
      (
        loadedReportParams.assetId !== this.state.assetId ||
        loadedReportParams.selectedDate !== this.state.selectedDate ||
        (loadedReportParams.groupId || "") !== (this.state.groupId || "")
      )
    );

    const calendarReport = this.state.calendarShow ? (
      <div ref={this.setWrapperRef} className="ParentCalender" style={{ position: "relative", zIndex: 100 }}>
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar maxDate={new Date()} onChange={this.onChangeDate} value={this.state.calendarSelectedDate} />
        </div>
      </div>
    ) : (
      ""
    );

    return (
      <Layout>
        <Helmet>
          <title>Temperature</title>
        </Helmet>
        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease report-modern-page temperature-report-page`
                : `contentWrapper contentWrapperSmooth report-modern-page temperature-report-page`
            }
          >
            <div className="reportHeaderTile">
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">Temperature Report</h2>
                  <p>Review temperature logs, exceptions and sensor activity for a selected asset and day.</p>
                </div>
                <i
                  className={this.props.headerHide ? `fa fa-window-restore` : `fa fa-window-maximize`}
                  onClick={this.handleWindow}
                />
              </div>
              <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                <div className="reportQuickActions">
                  <span className="reportQuickActionsLabel">Quick reports</span>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-MVTL")}>MVTL</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-Visit")}>Visit</button>
                  <button type="button" className="active" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Temperature")}>Temp</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Replay")}>Replay</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-LocationData")}>Location</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Timeline")}>Timeline</button>
                  <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Track")}>Track</button>
                </div>
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <Select
                    value={selectedGroupOption}
                    options={groupOptions}
                    styles={selectStyles}
                    onChange={this.handleGroupSelection}
                    isClearable
                    isSearchable
                    placeholder="Search group"
                    noOptionsMessage={() => "No groups found"}
                  />
                  {this.state.isLoading && (
                    <GroupWarning
                      warningText={true}
                      warningTextHead="No Groups Found"
                      warningTextBody=" You do not have any group memberships. Please contact Support to ensure your account configured correctly."
                    />
                  )}
                </div>
                <div className="inputElement reportPickerField">
                  <label>Asset</label>
                  <Select
                    value={selectedAssetOption}
                    options={assetOptions}
                    styles={selectStyles}
                    onChange={this.handleAssetSelection}
                    isClearable
                    isSearchable
                    isDisabled={!this.state.groupId && !this.state.assetId}
                    isLoading={this.state.assetLoader && this.state.groupId != ""}
                    placeholder={this.state.groupId ? "Search asset" : "Select group first"}
                    noOptionsMessage={() => "No assets found"}
                  />
                </div>
                <div className="inputElement reportPickerField">
                  <label>Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction}
                    dropDown={calendarReport}
                    placeholder={this.state.dataPlaceholder}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerActions">
                  {this.state.assetId != "" ? (
                    <Button className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"} variant="primary" onClick={this.handleCreateReport} size="sm">
                      <i className="fa fa-thermometer-half"></i>
                      Create Report
                    </Button>
                  ) : (
                    <Button className="reportPickerCreateButton" variant="primary" onClick={this.handleCreateReport} size="sm" disabled>
                      <i className="fa fa-thermometer-half"></i>
                      Create Report
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <TimeZoneConvert />
            <div className="reportBody">
              {this.state.reportLoader ? (
                <div className="loaderLine">
                  <br /> <GridLoader size={7} color={"#222222"} loading={this.state.reportLoader} />
                  <h1> &nbsp;Generating Report</h1>
                  <br />
                </div>
              ) : this.state.errorLoader ? (
                <AssetInforWarning warningText={true} warningTextMsg={this.state.errorMessage || "No Data Available"} />
              ) : this.state.showContent && this.state.reportStart ? (
                <React.Fragment>
                <TempSummary
                  start={utcToDate(this.state.reportStart)}
                  end={utcToDate(this.state.reportEnd)}
                  duration={this.state.reportDuration}
                  logNumber={this.state.tempDataLogList.length}
                  exceptionNumber={this.state.tempDataExceptionList.length}
                  generated={this.state.generatedDate}
                />
                <TemperatureChart
                  temperatureLogs={this.state.tempDataLogList}
                  totalGraph={this.state.totalGraph.filter(point => !isNaN(point[1]))}
                  totalGraphSecond={this.state.totalGraphSecond.filter(point => !isNaN(point[1]))}
                  timeUtc={this.state.timeUtc}
                  tempAEnabled={this.state.isTempAEnabled}
                  tempBEnabled={this.state.isTempBEnabled}
                  utcObj={this.state.utcObj}
                  xCategory={this.state.xPoint}
                  selectedDate={this.state.selectedDate}
                />

                <ExceptionTable
                  exceptionTable={this.state.tempDataExceptionList}
                  thresholdA={this.state.thresholdA}
                  thresholdB={this.state.thresholdB}
                  assetCustomerName={this.state.assetName}
                  calendarSelectedDate={this.state.calendarSelectedDate}
                />

                <LogTable logTable={this.state.tempDataLogList}
                  assetId={this.state.assetId}
                  tempAEnabled={this.state.isTempAEnabled}
                  tempBEnabled={this.state.isTempBEnabled}
                  doorSensorEnabled={this.state.isDoorSensorEnabled}
                  assetCustomerName={this.state.assetName}
                  calendarSelectedDate={this.state.calendarSelectedDate} />
                </React.Fragment>
              ) : (
                <AssetInforWarning />
              )}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  reportAssetId: state.reportAssetId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportAssetNameAction: setReportAssetName,
  setReportGroupIdAction: setReportGroupId,
};

export default connect(mapStateToProps, mapDispatchToProps)(Temperature);
